import { router, usePage } from "@inertiajs/react"
import { Select } from "@/components/ui/select"
import type { SharedProps } from "@/types/inertia"

// Avatar + current user + company-select dropdown. Reads everything from
// shared Inertia props so any page in the portal can render it without
// re-fetching.
export function CompanySwitcher() {
  const { props } = usePage<SharedProps>()
  const user = props.current_user
  const company = props.current_company
  const companies = props.companies ?? []

  if (!user) return null

  const initial = (user.name ?? user.email)[0]?.toUpperCase() ?? "?"

  const options = companies.map((c) => ({ value: c.id, label: c.name }))
  const selected = options.find((o) => o.value === company?.id) ?? null

  return (
    <div className="flex items-center gap-3 rounded-control bg-white/5 p-2">
      {user.avatarUrl ? (
        <img
          src={user.avatarUrl}
          alt={initial}
          className="h-9 w-9 shrink-0 rounded-full border border-border bg-app-panel2 object-cover"
        />
      ) : (
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-red font-semibold text-white">
          {initial}
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm">{user.name ?? user.email}</div>
        <Select<number>
          value={selected}
          onChange={(o) => o && o.value !== company?.id && router.post("/companies/switch", { company_id: o.value })}
          options={options}
          isSearchable={companies.length > 6}
          placeholder={companies.length === 0 ? "No companies" : "Select…"}
          isDisabled={companies.length === 0}
        />
      </div>
    </div>
  )
}
